import { useMobileStore } from 'store/mobile.store';

import { QueryResponse as CardResponse } from 'api/queries/getMainCard.query';

import { CommentsDesktop } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/comments/comments.desktop';
import { CommentsMobile } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/comments/comments.mobile';

interface Props {
    id: number;
    isVirtual: boolean;
    assigneeOptions: { text: string; value: string; url: string }[];
    card?: CardResponse;
    queryKeys?: string[];
}

const Comments = ({ id, isVirtual, assigneeOptions, card, queryKeys = [] }: Props) => {
    const isMobile = useMobileStore((state) => state.isMobile);
    return isMobile ? (
        <CommentsMobile id={id} isVirtual={isVirtual} assigneeOptions={assigneeOptions} queryKeys={queryKeys} />
    ) : (
        <CommentsDesktop
            id={id}
            isVirtual={isVirtual}
            assigneeOptions={assigneeOptions}
            card={card}
            queryKeys={queryKeys}
        />
    );
};

export default Comments;
